import { ApiService } from '../../../shared/service/Apiservice';
import { environment } from '../../../shared/enviroment/environment';
import { Address, AddressRequest } from '../dto/Address.dto';

export class AddressService {
  private apiRootServer = environment.api.apiRootServer;

  constructor(private apiService: ApiService) {}

  async getUserAddresses(): Promise<{ success: boolean; data?: Address[]; message?: string }> {
    return this.apiService.getRequest('user/address', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getDefaultAddress(): Promise<{ success: boolean; data?: Address; message?: string }> {
    return this.apiService.getRequest('user/address/default', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getAddressById(addressId: string): Promise<{ success: boolean; data?: Address; message?: string }> {
    return this.apiService.getRequest(`user/address/${addressId}`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async addOrEditAddress(payload: AddressRequest & { is_add_usecase: boolean; address_id?: string }): Promise<{ success: boolean; message?: string }> {
    return this.apiService.postRequest('user/address', payload, {
      apiRoot: this.apiRootServer,
    });
  }

  async deleteAddress(addressId: string): Promise<{ success: boolean; message?: string }> {
    return this.apiService.deleteRequest(`user/address/${addressId}`, {
      apiRoot: this.apiRootServer,
    });
  }

  async setDefaultAddress(addressId: string): Promise<{ success: boolean; message?: string }> {
    return this.apiService.putRequest(`user/address/${addressId}/default`, {}, {
      apiRoot: this.apiRootServer,
    });
  }
}
